var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCare2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 892.6 847.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #b7b6b6;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #c4bdbc;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #d8d0cf;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #d0807c;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #f4e7e4;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #5e5254;\r\n      }\r\n\r\n      .st6 {\r\n        fill: #af4a4a;\r\n      }\r\n\r\n      .st7 {\r\n        fill: #e29b86;\r\n      }\r\n\r\n      .st8 {\r\n        fill: #d3837c;\r\n      }\r\n\r\n      .st9 {\r\n        fill: #f4b199;\r\n      }\r\n\r\n      .st10 {\r\n        fill: #fffefd;\r\n      }\r\n\r\n      .st11 {\r\n        fill: #986f68;\r\n      }\r\n\r\n      .st12 {\r\n        fill: #e8be95;\r\n      }\r\n\r\n      .st13 {\r\n        fill: #d2827b;\r\n      }\r\n\r\n      .st14 {\r\n        fill: #e4f2ec;\r\n      }\r\n\r\n      .st15 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st16 {\r\n        fill: #cf807b;\r\n      }\r\n\r\n      .st17 {\r\n        fill: #fafffd;\r\n      }\r\n\r\n      .st18 {\r\n        fill: #706466;\r\n      }\r\n\r\n      .st19 {\r\n        fill: #e3d1cf;\r\n      }\r\n\r\n      .st20 {\r\n        fill: #f0e7e2;\r\n      }\r\n\r\n      .st21 {\r\n        fill: #514b4c;\r\n      }\r\n\r\n      .st22 {\r\n        fill: #d16565;\r\n      }\r\n\r\n      .st23 {\r\n        fill: #ffd49c;\r\n      }\r\n\r\n      .st24 {\r\n        fill: #865d5b;\r\n      }\r\n\r\n      .st25 {\r\n        fill: #ec827d;\r\n      }\r\n\r\n      .st26 {\r\n        fill: #f7f2f0;\r\n      }\r\n\r\n      .st27 {\r\n        fill: #f9c6b7;\r\n      }\r\n\r\n      .st28 {\r\n        fill: #e59e89;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M505.4,370.7c.9,8.8,2.2,15.6,2.2,15.6l14.9,1.3-7-16.2-10.1-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M399.4,184.9c31.6,28.1,38.1,44,70.9,93.7,32.8,49.7,62.3,82.5,62.3,82.5l-22.8,13.4s-38.9-25.8-64.3-53.4c-31.4-34.1-50.2-61.9-69.5-83.5l23.4-52.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M337.5,7s-7.7-7.7-24.5-.9c-16.8,6.8-30,32.7-22.7,54.5,7.3,21.8,8.6,37.7,3.6,45.4-3.2,4.9-9.5,3.6-9.5,3.6,0,0,3.6,6.8,11.4,4.5s8.2-10.9,8.2-10.9c0,0,.9,10.4-6.4,16.3-7.3,5.9-15,2.3-15,2.3,0,0,5.9,13.6,25.4,6.8,19.5-6.8,21.3-24.1,21.8-31.3s7.7-90.3,7.7-90.3h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M786.9,847.2h22.3s3.7-56.9-21.4-102.5l-27.9,16.1s24.2,32.3,27,86.3h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 770.6,
    cy: 747,
    rx: 26.6,
    ry: 13.7,
    transform: "translate(-226.2 349.2) rotate(-22.4)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.4,847.2h-22.3s-3.7-56.9,21.4-102.5l27.9,16.1s-24.2,32.3-27,86.3h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 123.7,
    cy: 747.1,
    rx: 13.7,
    ry: 26.6,
    transform: "translate(-614.3 577.4) rotate(-67.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M427.7,377.3c-7-5.3-9.6-12.7-11.8-21.1s-3.7-12.9-5.5-12.7c-3.1.4-2,5.9-1.3,11,.4,3.1-.4,9-.4,9,0,0-8.2-3.6-12.5-8.3-6.6-7.2-10.8-16.5-14-14.7-2.3,1.2,1.8,8.1,4,11.6,2.2,3.5,5.7,9,5.7,9,0,0-7.2-4.2-11-7.5-3.7-3.3-8.1-8.3-10.3-6.8s3.7,8.5,7,11.8c3.3,3.3,8.1,7.7,8.1,7.7,0,0-5-1.3-9.4-3.1-4.4-1.8-7.5-4.2-8.5-2.4-1.1,1.8,12.5,12.3,23.9,19.5s22.1,13.4,22.1,13.4l14-16.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M398.3,796.9c3.2,36.9,50.6,26.2,52.1,37.4,1.5,11.2-53.7,9.8-60.5,1.8-8.2-9.6-9.4-43.3-9.4-43.3l17.7,4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M241,796.9c-8,36.9,21.1,26.2,19.3,37.4-1.8,11.2-38.3,9.8-43.3,1.8-6.1-9.6,5.8-43.3,5.8-43.3l18.3,4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.2,367.7c-10.8,43.4-2.7,220.2-4.2,249.5-3.7,68.3-3.9,177.6-3.1,185,0,0,30.7,14,56.6,1.5,0,0,19.4-127.5,25.6-169,7.4-49.3,14-108.4,14-108.4l23.4,104.5s11.7,94,45.1,177.7c0,0,23.3,7.8,50.6-9.3,0,0-18.4-138.5-20.6-180.4-2.2-41.9-37.4-222-37.8-246.8l-149.5-4.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M370.8,378.9s-26.2,19.8-70.2,19.8-86.1-11.1-94.1-23.8l6.7-20.7s36,21.1,84.2,20.2c48.3-.9,69.3-14,69.3-14l4,18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M762.3,316.8c8.6,3.3,6.7,17.2,6.7,17.2,0,0,10.2-1,8.8,17.8s-19.7,35.2-41.2,31.6c-16.1-2.6-17.9-17.5-17.9-17.5l43.7-49.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M726.5,376.9s17.5,5.7,29-18.4c11.4-24.1,9-48,4-62.7-7.9-22.8-34.7-39-63.6-28.1,0,0-13.2-6.6-28.1,7.5-13.2,12.5-17.5,29.4-16.7,43,.9,13.6,2.2,25-4.4,29.8s-8.8.4-8.8.4c0,0,2.6,7.9,11.8,5.7,9.2-2.2,76.8,22.8,76.8,22.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M672.5,413c-14.9,7.4-27.2,8.2-38.6,9.1,0,0-18.6,38.8-23.2,52.2s-11.1,37.4-11.1,37.4h158.5s28.1-71.9,16.4-78.4c-11.7-6.4-36.6-10.8-42.5-21.3-5.8-10.5-59.5.9-59.5.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M697.5,423.4c-15.3-.9-25-10.4-25-10.4,7.2-3.8,3.1-28.6,3.1-28.6l40-30.7,13.3-2.5c-4.8,42.6.3,53.4,3.1,60.9.5,1.1-18.2,12.3-34.5,11.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M727.1,389c-.3-5.3-.3-11.8.2-20l-1.7-2.9-49.9,19.1c.5,3,1.8,13.6.5,21,5.2,1.7,32,8.6,50.9-17.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M675.1,399.6c4.9,1.6,31,7.7,48.7-20.2,9.4-14.9,16.6-40.5,16-52.7s-7.7-51.3-46.5-45.2c0,0-30.4,5.4-36.7,53.3,0,0-3.8,8.3-3.4,18.3,1.9,41.9,17,44.9,21.8,46.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M685.1,276.4c-8.1,24.3,35,16.7,42.7,55.6.5,7.1-2,15.6,6.8,18.3l12.1-10s9.5-24.3-2.5-48.7c-12-24.4-49.7-33-59.1-15.2h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M677.3,323.9c-1.2,2.1-4.4-.8-12,.1-2.4.3-6.3,1.2-6.8,0-.6-1.3,1-5.2,8-5.6,8.5-.5,12.5,2.7,10.9,5.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M693.8,326.1c0,2.9,5.1,1.9,12.5,4.8,7.8,3.1,7.5,4.5,9.2,3.4.9-.6,1.2-5.3-8.7-9.5-8.8-3.8-13.1-1.6-13.1,1.3h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M692.7,383.7c.2,1.3-1.5,3.9-5.2,4.5-3.8.6-6.8-1.4-7-2.6s2.6-.4,6-1,6-2.2,6.2-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M699.4,369.6s-7,5.3-17.9,5.3-11.5-4.1-11.5-4.1c0,0,1.6,10.4,15.4,9.3,10.4-.8,14-10.6,14-10.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M683.1,326.8s0,.2.2.5c.1.3.4.9.5,1.5.3,1.3.6,3.2.5,5.4,0,2.2-.5,4.8-1.4,7.4s-1,2.6-1.7,3.9c-.7,1.3-1.7,2.6-2.8,3.6-2,2.2-4.6,3.8-5.7,5.5-.3.4-.4.8-.5,1.2h0c0,.2,0-.2,0-.2h0v.4s0,.5,0,.5c0,0,0,.1,0,.2.2.6.8,1.3,1.6,1.8,1.5,1.1,3.1,1.7,4.2,2.2.5.2,1,.4,1.3.5.3.1.4.2.4.2h0c.5.2.8.8.6,1.4-.2.5-.7.8-1.1.7,0,0-.2,0-.5,0-.3,0-.8-.1-1.5-.3-1.3-.3-3-.8-5.1-2-1-.7-2.2-1.6-2.8-3.3-.2-.4-.2-1-.3-1.5v-.5s0-.2,0-.2h0c0-.1,0-.2,0-.2v-.2s0,0,0,0c.2-.8.6-1.6,1-2.3.9-1.4,2.2-2.3,3.3-3.1,1.1-.8,2.2-1.6,3.2-2.5,1-.9,1.8-1.8,2.5-2.9.7-1.1,1.2-2.3,1.6-3.5.8-2.4,1.3-4.7,1.4-6.8.1-2,0-3.7-.4-4.8-.2-.6-.2-.8-.4-1.1-.2-.3-.2-.5-.2-.5-.3-.5,0-1.2.5-1.4s1.2,0,1.4.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M734.2,350s8-13.2,15.4-5.1c6.4,7-6.8,29.4-21.5,20.6,1.3-6,3-11.5,6-15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M744,358.1c-2.5,3.3-6.1,4.3-7.4,2.6-1.3-1.6-.3-5.6,2.3-8.9,2.5-3.3,5.6-4.6,6.9-3,1.3,1.6.7,6-1.8,9.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M707,348.3s-9.7.8-13.8-5.4c0,0-.5,5,5.2,7s8.6-1.6,8.6-1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M672.7,339.9s-1.1,4.4-5,4.8c-3.8.5-6.2-1.6-6.2-1.6,0,0,4,.1,6.2-.5,3.4-1,5-2.6,5-2.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M704.6,313.6s-11.6-3.1-18.4-4.2-14.7-.4-14.7-.4c0,0,6.6-3,15.6-1.8s17.5,6.3,17.5,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M697.7,305.4s-5.7-1.5-9.1-2c-3.4-.5-7.3-.2-7.3-.2,0,0,3.3-1.4,7.7-.8s8.7,3,8.7,3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M662,332.3c-1.1,2.3-.8,4.7.7,5.4,1.5.7,3.6-.5,4.7-2.8s.8-4.7-.7-5.4c-1.5-.7-3.6.5-4.7,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M673,338s-1.2-3.9-6.2-6c-3.5-1.4-4.1,2.1-7.5,1.9-1.2,0-2.9-1.7-2.8-3.7,0,0,.8,1.6,2.5.9,1.3-.6,4.8-4.3,9-2.7,5.2,2,6.1,6.4,5,9.6h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M696.2,339.6c.5-2.5,2.5-4.9,4.5-5.2s3.2,1.5,2.7,4.1c-.5,2.5-2.5,4.9-4.5,5.2s-3.2-1.5-2.7-4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M694.3,339.2s2.8-2.5,8.7-.8c4.1,1.2,3.7,3.6,6.8,5.5,1.2.7,3.8.6,5.1-1.3,0,0-1.9.9-2.8-1-.8-1.5-2.7-5.5-7.6-7.4-4.9-1.9-8.9,1.3-10.2,5h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M774.4,433.3c18.1,10.5,25.7,26.9,35.7,47.4s14.6,32.2,14.6,32.2h-57.9s-8.6-13.6-18.7-24.6c-15.2-16.4,8.4-65.4,26.3-55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M633.9,422.1c-41.7.1-94.3-4.4-134.2-16.2s-72-28.5-72-28.5l-14,14.5s42.1,43,86.9,59.7,75,25,109.7,28.1l23.7-57.5h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M734.3,336.8c0,0-.1,0-.2,0-.6-.1-1-.7-.9-1.3,1.8-10.5-2.6-22.1-10.9-28.8-.5-.4-.6-1.1-.2-1.6.4-.5,1.1-.6,1.6-.2,9.1,7.3,13.7,19.4,11.7,30.9,0,.6-.6,1-1.1,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M739.8,339.8c-.2,0-.3,0-.5-.1-.6-.3-.8-.9-.6-1.5,1.9-4.2,2-9.2.4-13.5-.2-.6,0-1.2.7-1.5s1.2,0,1.5.6c1.9,4.9,1.8,10.5-.4,15.2-.2.4-.6.7-1,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M711.2,297.7c-.3,0-.6-.1-.8-.3-2.3-2.2-5.3-3.7-8.2-5.1h-.3c-3.4-1.8-6.6-3.5-9-6.1-2.9-3.2-3.9-7.4-2.7-10.8.2-.6.9-.9,1.5-.7.6.2.9.9.7,1.5-1,2.6-.1,5.9,2.2,8.5,2.1,2.4,5,3.9,8.3,5.5h.3c3.1,1.6,6.3,3.2,8.8,5.7.5.4.5,1.2,0,1.6-.2.2-.5.3-.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M757.7,326.9s-.1,0-.2,0c-.6,0-1.1-.7-1-1.3,2.2-15.5-3.2-32.1-14.2-43.2-.4-.5-.4-1.2,0-1.6.5-.4,1.2-.4,1.6,0,11.4,11.7,17.1,29,14.8,45.2,0,.6-.6,1-1.1,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M744.7,293.8c-.4,0-.7-.2-1-.5-4.8-7.4-12.4-13-20.8-15.4-.6-.2-1-.8-.8-1.4.2-.6.8-1,1.4-.8,9,2.6,17,8.5,22.1,16.4.3.5.2,1.2-.3,1.6-.2.1-.4.2-.6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M725.3,271.7c0,0-.2,0-.3,0-5.2-1.5-10.8-1.8-16.2-.9-.6.1-1.2-.3-1.3-.9,0-.6.3-1.2.9-1.3,5.7-1,11.7-.6,17.2,1,.6.2,1,.8.8,1.4-.1.5-.6.8-1.1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M671.7,279.4c-.3,0-.5,0-.7-.3-.5-.4-.5-1.1-.1-1.6,4.5-5.3,11.7-8.1,18.7-7.3.6,0,1.1.6,1,1.3,0,.6-.6,1.1-1.3,1-6.1-.7-12.7,1.9-16.7,6.5-.2.3-.5.4-.9.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M656.5,320.1c-.5,0-1-.3-1.1-.9-2.8-10.5,0-22.5,7.3-30.7.4-.5,1.1-.5,1.6-.1.5.4.5,1.1,0,1.6-6.7,7.6-9.4,18.8-6.8,28.5.2.6-.2,1.2-.8,1.4,0,0-.2,0-.3,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M741,379.1c-2.6,0-5.3-.4-7.8-1-.6-.2-1-.8-.8-1.4s.8-1,1.4-.8c7,1.9,14.7,1,21-2.7,6.3-3.6,11.1-9.8,13-16.8.2-.6.8-1,1.4-.8.6.2,1,.8.8,1.4-2.1,7.6-7.2,14.3-14,18.2-4.5,2.6-9.7,4-14.9,4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M772.8,357.7c-.2,0-.4,0-.6-.2-.5-.3-.7-1-.4-1.6,1.6-2.7,2.2-5.9,1.6-9-.6-3-2.3-5.9-4.7-7.8-.5-.4-.6-1.1-.2-1.6.4-.5,1.1-.6,1.6-.2,2.9,2.2,4.9,5.6,5.5,9.2.7,3.6,0,7.4-1.9,10.6-.2.4-.6.6-1,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M750.2,366.7c-.6,0-1.1-.5-1.1-1.1,0-.6.5-1.2,1.1-1.2,3.1-.1,6.3-2.1,8.1-5,1.7-2.7,2.4-6.2,2.1-9.9-.2-2.2-.7-3.9-1.6-5.2-1-1.5-2.5-2.5-4-2.7-.6,0-1.1-.6-1-1.2s.6-1.1,1.2-1c2.2.2,4.4,1.6,5.7,3.7,1.1,1.6,1.7,3.7,1.9,6.2.4,4.2-.5,8.2-2.4,11.3-2.3,3.6-6.1,5.9-10,6.1h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M735.6,310.2c-.4,0-.8-.2-1-.6-4.6-9.5-13.3-17.1-23.3-20.4-.6-.2-.9-.8-.7-1.4s.8-.9,1.4-.7c10.6,3.4,19.9,11.5,24.7,21.6.3.6,0,1.2-.5,1.5-.2,0-.3.1-.5.1h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M407.1,285.5s35.2-13.7,46.5-44.5c0,0-46.4-78.6-81.2-94.1l-16.1,81.3s31.6,39.7,50.9,57.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M269.4,181.2c14.4-20.1,40.2-36.2,58.4-36.5,35-.6,54.6,1.4,64.9,21.2,10,19.1,14.6,59.5,11.3,75.7-5.6,27.3-22.1,32-30.6,62.1-7,25.1-2.5,59.4-2.5,59.4,0,0-26.2,19.8-70.2,19.8s-86.1-11.1-94.1-23.8c0,0,4.3-18,20.8-76.9,12.3-43.9,26.2-78.7,42.1-100.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M315,153.7c2.8,20.6,60.8,49.7,60.8,49.7,0,0,10.2-37.9,6.8-46.6s-15.1-14.1-35.4-14.1-33.3,3.6-32.2,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M375.8,203.4s4.7-17.7,6.7-31.6c-3.1,3.2-8.2,7.1-15.8,8.7-12.8,2.8-22.6,1.7-27.7.7,17,12.3,36.8,22.2,36.8,22.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M336.7,113.8s-35-15-29.2-61.8c5.2-42,42.9-61.3,71-47.6,0,0,23.2-5.9,39.1,25.8,16,31.7-24.9,60.6-24.9,60.6l-56,23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M322,151.7c11.4-27.9,11.3-56.4,11.3-56.4l23.1-1.1,24.2,5.2c-4.1,15.1-11.1,43.9-7.2,57.3.7,2.5-12.9,8.9-25.1,7.6-13.8-1.5-27-10.8-26.2-12.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M372.3,146.9c0-9.5,2.1-21.6,4.5-32.2l-37.8-19.7-5.6.3s0,11.8-3,27.7c5.9,20.4,38.3,39.7,43.2,39.7s8.7-6.8,8.7-6.8c-1.7-3.7-5-6.8-9.9-9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M381.6,145.8c-5.1.4-32.6-7.1-42.4-38.1-5.2-16.5-4.5-35.9-.9-47.3,3.6-11.5,20.1-46.9,55.4-31.3,0,0,28.6,12.8,23.2,60-4.9,42.4-29.7,56.4-35.4,56.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M402.9,26.2c1.6,25.1-37.5,7.2-54.4,42.2-2.2,6.7-2,15.4-11,15.7l-9-12.5s-3-25.4,14.5-45.6c17.5-20.2,55.5-19,60,.3h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M398.8,70.7c1.1,2.1,4.3-.5,11.8.5,5.2.7,7.7,4.8,8.3,3.6.6-1.3-.7-6.8-8.8-8.4-8.2-1.6-12.8,1.6-11.4,4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M382.2,69.4c-.8,2.8-6.3-.7-14.1.5-8.1,1.3-11,5.5-12.4,4-.7-.8,2.8-8,13.3-9.4,9.3-1.3,13.9,2.1,13.2,4.9h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M389.2,109.5s.7,0,2-.2c1.4-.2,3.2-.5,5.4-1.6,1.1-.5,2.2-1.3,3.2-2.4.5-.6,1-1.2,1.3-2,.2-.4.4-.8.4-1.3,0-.2,0-.5,0-.8s0-.3,0-.4v-.2s0-.1,0-.1h0c0,0,0,0,0,0v-.4c-.1,0-.5-.8-.8-1-.2-.2-.4-.3-.5-.4l-.9-.7-1.6-1.2c-1-.8-2-1.8-2.9-2.7-1.8-2-3-4.3-3.5-6.8-.5-2.4-.3-4.8.2-6.8.5-2,1.1-3.6,1.6-4.7.5-1.1.9-1.7.9-1.7h0c.1-.3,0-.7-.3-.9-.3-.2-.7,0-.8.2,0,0-.4.6-1,1.7-.6,1.1-1.5,2.8-2.1,4.9-.6,2.1-1.1,4.8-.8,7.7.4,2.9,1.6,5.8,3.5,8.3.9,1.2,2,2.3,3,3.4l1.6,1.4.7.7.2.2s-.3-.5-.1-.1c-.2-.7,0-.2-.1-.3h0s0,0,0,0c0,0,0,.1,0,.2,0,.2,0,.4-.1.6-.1.4-.4.8-.6,1.2-.5.8-1.3,1.4-2.1,2-1.6,1-3.2,1.6-4.3,1.8-1.2.3-1.9.4-1.9.4-.6.1-1,.7-.9,1.3.1.6.6.9,1.1.9h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M338.2,81.3s-4.4-14.5-13.4-8.7c-4.5,2.9-4.9,12.2-1.4,18.9,2.6,5,9.4,9.7,14.4,6.5,0,0,4.5-1.3.4-16.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M327.8,89.1c1.7,4.1,5.2,6.1,7,4.8s1.8-5.7,0-9.8-4.6-6.4-6.4-5-2.4,6-.6,10.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M375.3,114.8s4.5,3.1,10.3,4.1c8.2,1.4,11.1-.6,11.1-.6,0,0-2.6,9.2-12.6,7.1-7.6-1.6-8.9-10.6-8.9-10.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M399.8,82.4s2,3.8,7.1,4c4,.2,3.7-2.8,6.4-3.5,1.1-.3,3.1.8,3.4,2.7,0,0-1.1-1.3-2.5-.2-1.1.9-3.3,5.1-7.6,4.6-5.2-.6-7.1-4.4-6.9-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M379.5,81.6s-2.6,4-8.4,3.3c-3.8-.5-4.7-2.9-7.3-3.8-1.2-.4-3.6.2-4.5,2.2,0,0,1.6-1.1,2.8.4,1,1.3,3.8,5.1,8.4,5.4,5,.3,8.5-3.1,8.9-7.4h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M313.4,196.9s8.9,73.2,29.4,111.8c28.9,54.5,83.1,92.1,83.1,92.1l-4.4,23.6s-76.9-19.3-122.3-90.6c-32.6-51.4-33.7-127-33.7-127l48-9.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M425.7,399.7c8.5,4.6,15,3.9,25.1,2.9,10.1-1,18.4-3.1,19.3-.4,1.3,4-13,8.4-18.3,11,0,0,7.4,14.5,21.8,24.8,0,0-4.6,1.7-13.8-2.1,0,0-.4,5.5-10.7.7,0,0,.6,2.8-4.4,2.5-6.8-.4-17.5-7.7-23.1-14.5s4.2-24.8,4.2-24.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M36.3,518.7h831.8v112.9c0,75.9-61.6,137.5-137.5,137.5H173.7c-75.9,0-137.5-61.6-137.5-137.5v-112.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.3,518.7v22.5h672.7v101.8c0,60.6-49.1,109.7-109.7,109.7H143.6c-23.4,0-45-7.3-62.8-19.8,24.5,22.5,57.1,36.2,92.9,36.2h556.8c75.9,0,137.5-61.5,137.5-137.5v-112.9H36.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 36.3,
    y: 518.7,
    width: 831.8,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M881.5,502.4H11.1c-6.1,0-11.1,5-11.1,11.1h0c0,6.1,5,11.1,11.1,11.1h870.4c6.1,0,11.1-5,11.1-11.1h0c0-6.1-5-11.1-11.1-11.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M696.2,439.9c-.7,0-1.4,0-2.2-.2-3.7-.6-6.8-2.5-8.6-5.4-.3-.5-.2-1.2.3-1.6.5-.3,1.2-.2,1.6.3,1.5,2.3,4.1,3.9,7.1,4.4,3,.5,6-.2,8.1-2,.5-.4,1.2-.3,1.6.2.4.5.3,1.2-.2,1.6-2.1,1.7-4.8,2.6-7.7,2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M449,437.7c-.2,0-.4,0-.5-.1-.1,0-3.5-1.9-6.1-4.6-.4-.5-.4-1.2,0-1.6s1.2-.4,1.6,0c2.3,2.5,5.5,4.1,5.5,4.2.6.3.8,1,.5,1.5-.2.4-.6.6-1,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M459.8,437c-.2,0-.4,0-.5-.1-.1,0-3.5-1.9-6.1-4.6-.4-.5-.4-1.2,0-1.6s1.2-.4,1.6,0c2.3,2.5,5.5,4.1,5.5,4.2.6.3.8,1,.5,1.5-.2.4-.6.6-1,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M324.6,353.2c-.2,0-.4,0-.6-.2-5.2-3.4-9.5-8.4-12-14-.3-.6,0-1.2.6-1.5.6-.3,1.2,0,1.5.6,2.4,5.3,6.4,9.9,11.2,13,.5.3.7,1,.3,1.6-.2.3-.6.5-1,.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M274.8,303.1s38.6,4.4,68.4-16.7c0,0-22.2-124.8-57-113.2-55.3,18.4-11.4,129.9-11.4,129.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M182.8,847.2h-22.3s-3.7-56.9,21.4-102.5l27.9,16.1s-24.2,32.3-27,86.3h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 199.1,
    cy: 747.1,
    rx: 13.7,
    ry: 26.6,
    transform: "translate(-567.6 647.1) rotate(-67.7)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M711.5,847.2h22.3s3.7-56.9-21.4-102.5l-27.9,16.1s24.2,32.3,27,86.3h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 695.3,
    cy: 747,
    rx: 26.6,
    ry: 13.7,
    transform: "translate(-231.8 320.5) rotate(-22.4)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M356.8,273.5c-.6,0-1.2-.5-1.3-1.1-.1-.7.4-1.4,1.1-1.5,11.3-1.9,21.6-8.3,28.2-17.6.4-.6,1.2-.7,1.8-.3.6.4.7,1.2.3,1.8-7,9.9-17.9,16.8-29.9,18.7,0,0-.1,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M366,278c-.6,0-1.2-.5-1.3-1.1-.1-.7.4-1.4,1.1-1.5,3.6-.6,7.1-2.2,10.1-4.4.6-.4,1.4-.3,1.8.3.4.6.3,1.4-.3,1.8-3.3,2.5-7.1,4.2-11.2,4.9,0,0-.2,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M303.1,86.3c-.6,0-1.1-.4-1.1-1-.5-5.3-2.4-11.3-4.1-17.1-1.5-5-3-10.1-3.8-14.7-1.8-11.2,1.3-20.1,4.9-28.1,4.7-10.4,14.8-17.3,24.6-16.7.6,0,1.1.6,1.1,1.2,0,.6-.6,1.1-1.2,1.1-8.9-.5-18.1,5.8-22.4,15.4-4.7,10.5-6.1,18.3-4.8,26.9.7,4.5,2.2,9.5,3.7,14.4,1.8,5.9,3.6,12,4.2,17.6,0,.6-.4,1.2-1,1.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M310.2,102.4s-.1,0-.2,0c-.6,0-1.1-.7-1-1.3.7-4.8.3-9.8-1.2-14.5-.2-.6.1-1.2.8-1.4.6-.2,1.2.2,1.4.8,1.5,5,2,10.3,1.2,15.5,0,.6-.6,1-1.1,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M300.5,126.6c-.5,0-1-.4-1.1-1-.1-.6.3-1.2,1-1.3,11.5-1.8,18.8-8.9,19.9-19.4,0-.6.6-1.1,1.3-1,.6,0,1.1.6,1,1.3-1.3,11.5-9.4,19.5-21.8,21.4,0,0-.1,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M343.9,62c-.2,0-.3,0-.5-.1-.6-.3-.8-1-.5-1.5,6.3-12.7,18.8-22,32.7-24.3,1.3-.2,2.6-.4,3.9-.5,3.1-.4,6.1-.8,8.9-1.9,3.5-1.4,7.1-4.8,6.8-8.8,0-.6.4-1.2,1-1.2.6,0,1.2.4,1.2,1,.4,5.2-4,9.4-8.2,11.1-3,1.2-6.3,1.6-9.5,2-1.3.2-2.5.3-3.8.5-13.2,2.2-25.1,11.1-31.1,23.1-.2.4-.6.6-1,.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M385.1,27.1c-.3,0-.7-.1-.9-.4-.4-.5-.3-1.2.2-1.6,2.6-2,4.6-4.9,5.6-8,.2-.6.8-.9,1.4-.7s.9.8.7,1.4c-1.1,3.6-3.4,6.8-6.4,9.1-.2.2-.5.2-.7.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M316,40.5c0,0-.2,0-.3,0-.6-.2-1-.8-.8-1.4,2.9-11.7,8.5-17.6,14.4-23.1,6.6-6.1,15.1-9.9,24-10.8.6,0,1.2.4,1.2,1s-.4,1.2-1,1.2c-8.4.8-16.4,4.5-22.6,10.2-5.7,5.2-11,10.8-13.7,21.9-.1.5-.6.9-1.1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M374.3,9.9c-.3,0-.5,0-.7-.3-2.2-1.9-5.3-2.8-8.2-2.5-.6,0-1.2-.4-1.3-1,0-.6.4-1.2,1-1.3,3.5-.4,7.2.7,9.9,3,.5.4.5,1.1.1,1.6-.2.3-.5.4-.9.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M335.1,68h0c-.6,0-1.1-.6-1.1-1.2.2-6.4,3.1-12.7,7.8-17.1.5-.4,1.2-.4,1.6,0,.4.5.4,1.2,0,1.6-4.2,4-6.8,9.7-7,15.5,0,.6-.5,1.1-1.1,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M327.5,65.8c-.5,0-1-.4-1.1-.9-.8-3.8.1-7.8,2.3-10.9.4-.5,1.1-.6,1.6-.3.5.4.6,1.1.3,1.6-1.9,2.6-2.6,6-2,9.1.1.6-.3,1.2-.9,1.3,0,0-.2,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M416.5,48.5c-.5,0-1-.3-1.1-.8-2-7.9-6.7-15-13.1-19.9-.5-.4-.6-1.1-.2-1.6.4-.5,1.1-.6,1.6-.2,6.8,5.3,11.8,12.8,13.9,21.2.2.6-.2,1.2-.8,1.4-.1,0-.2,0-.3,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M309.4,23.2c-.2,0-.4,0-.6-.2-.5-.3-.7-1-.4-1.6,2.2-3.5,6-6,10.1-6.7.6-.1,1.2.3,1.3.9s-.3,1.2-.9,1.3c-3.5.6-6.7,2.7-8.5,5.6-.2.3-.6.5-1,.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M328.1,103.4c-.2,0-.5,0-.6-.2-13.1-9.2-18.4-29-16.8-43.7,0-.6.6-1.1,1.3-1,.6,0,1.1.6,1,1.3-1.5,13.8,3.6,33,15.9,41.6.5.4.6,1.1.3,1.6-.2.3-.6.5-.9.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M319.5,54.1h0c-.6,0-1.1-.6-1.1-1.2.6-10.5,5.2-20.8,12.7-28.2.4-.5,1.2-.4,1.6,0,.4.5.4,1.2,0,1.6-7.1,7-11.5,16.8-12,26.7,0,.6-.5,1.1-1.1,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M405.4,21.4c-.4,0-.7-.2-.9-.5-4.2-6.2-11.5-10.1-19.1-10.1h0c-.6,0-1.1-.5-1.1-1.1s.5-1.1,1.2-1.1c8.3,0,16.3,4.2,21,11.1.4.5.2,1.2-.3,1.6-.2.1-.4.2-.6.2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M499.3,379.1c3.1-1.6,20.4,4.4,39.7,8.5,19.3,4,39.9,5,43.4,6.6,3.5,1.6,3.9,12.8,3.1,24.4s-2.5,21.2-7,23.5-26.1,0-46.9-3.5c-20.8-3.6-38.5-9.4-42.3-13.1-3.7-3.7-1.9-15.9-.1-25.8s6.3-18.7,10-20.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M508.1,412.1c0,3.1-2.7,5.8-6,5.9s-6-2.3-6-5.5,2.7-5.8,6-5.9c3.3-.1,6,2.3,6,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M515.7,400.9c0,1.5-1.2,2.7-2.8,2.7-1.5,0-2.8-1.1-2.8-2.5s1.2-2.7,2.8-2.7c1.5,0,2.8,1.1,2.8,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M507.7,387.4c0,2.1-1.7,3.8-3.8,3.9s-3.8-1.5-3.8-3.6,1.7-3.8,3.8-3.9,3.8,1.5,3.8,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M528.8,421.7c0,2.1-1.7,3.8-3.8,3.9s-3.8-1.5-3.8-3.6,1.7-3.8,3.8-3.9c2.1,0,3.8,1.5,3.8,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M562.7,426.2c0,3-2.7,5.6-6,5.7-3.3.1-6-2.2-6-5.3s2.7-5.6,6-5.7c3.3-.1,6,2.2,6,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M567.1,414.4c0,1.5-1.3,2.7-3,2.7s-3-1.1-3-2.5,1.3-2.7,3-2.7,3,1.1,3,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M579.8,400.4c0,2.2-1.9,4-4.2,4.1s-4.2-1.6-4.2-3.8,1.9-4,4.2-4.1c2.3,0,4.2,1.6,4.2,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M577.4,425.7c0,1.3-1.1,2.5-2.4,2.5s-2.4-1-2.4-2.3,1.1-2.5,2.4-2.5,2.4,1,2.4,2.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M509.8,374.5c11.9,14.3,11,12.8,16,22.4,5,9.6,5.5,21.9,8.5,21.9s2.4-5.4,2-11.4c-.4-5.7-1.5-11.3-1.1-11.4.9-.2,3.3,3.7,6,9.8,2.6,5.9,5.8,14.8,8.4,13.5,2.5-1.3.6-10.3-1-15.6-1.6-5.3-5.1-13.2-4.6-13.6.5-.5,2.5,2,6,6.8,3.4,4.8,5.3,11.7,7.8,10.7,2.5-1-.9-14.3-5.3-21.9-7.4-12.8-13.3-18-19.9-24.6l-15,3.7-7.8,9.7h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M73.4,502.4h737.9s-14.9-17.9-37.7-19.9-31.6,8-31.6,8c0,0-36.6-43.7-95-42.4-58.5,1.3-90.1,34.5-90.1,34.5,0,0-2.6-12.9-27.2-16.9-24.6-4-39.5,15.9-39.5,15.9,0,0-30.7-41.7-76.3-51.7s-86.9,15.9-86.9,15.9c0,0-11.4-18.9-38.6-11.9-27.2,7-33.3,24.9-33.3,24.9,0,0-38.6-20.9-82.5-11.9-43.9,9-53.5,37.8-53.5,37.8,0,0-10.5-8-27.2-2s-18.4,19.9-18.4,19.9h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M482.6,493.6c-.6,0-1.2-.3-1.6-.9-18.8-30.5-49.6-50.9-82.2-54.4-1-.1-1.8-1-1.7-2.1.1-1,1-1.8,2.1-1.7,33.8,3.6,65.6,24.6,85,56.1.5.9.3,2-.6,2.6-.3.2-.6.3-1,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M413,456.4c-.4,0-.8-.1-1.1-.4-9.8-7.1-22.3-9.1-33.4-5.4-1,.3-2-.2-2.4-1.2-.3-1,.2-2,1.2-2.4,12.3-4.1,26-1.9,36.8,5.9.8.6,1,1.8.4,2.6-.4.5-.9.8-1.5.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M554.9,494.7c-.7,0-1.3-.4-1.6-1-6-10.9-17.2-17.6-28.5-17.2-1,0-1.9-.8-1.9-1.8s.8-1.9,1.8-1.9c12.7-.5,25.2,7,31.9,19.1.5.9.2,2-.7,2.5-.3.2-.6.2-.9.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M320.6,456.4c-.5,0-1.1-.2-1.5-.7-4.9-6.1-11.8-10.3-19-11.3-7.2-1-14.8,1-20.8,5.5-.8.6-2,.5-2.6-.4-.6-.8-.5-2,.4-2.6,6.9-5.1,15.5-7.4,23.6-6.2,8.1,1.2,15.9,5.8,21.4,12.7.6.8.5,2-.3,2.6-.3.3-.8.4-1.2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M319.4,476.4c-.8,0-1.6-.5-1.8-1.4-1.7-6-6.9-10.4-12.3-10.6-1,0-1.8-.9-1.8-1.9s.8-1.8,1.9-1.8c7,.2,13.6,5.8,15.8,13.3.3,1-.3,2-1.3,2.3-.2,0-.3,0-.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M263,487.3c-.5,0-1.1-.2-1.4-.7-19.3-23.1-49.4-33.5-76.7-26.5-1,.3-2-.3-2.3-1.3-.3-1,.3-2,1.3-2.3,28.7-7.4,60.3,3.5,80.5,27.7.7.8.6,2-.2,2.6-.4.3-.8.4-1.2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M172.6,479.2c-.5,0-1-.2-1.3-.5-.7-.7-.7-1.9,0-2.6,7.7-7.6,18.3-11.1,28.5-9.4,1,.2,1.7,1.1,1.5,2.1s-1.1,1.7-2.1,1.5c-8.9-1.5-18.4,1.6-25.2,8.4-.4.4-.8.5-1.3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M132.4,496.2c0,0-.2,0-.3,0-1-.1-1.7-1.1-1.6-2.1,2.2-15.6,13.8-29,27.7-31.8,1-.2,2,.5,2.2,1.5.2,1-.4,2-1.5,2.2-12.3,2.5-22.7,14.5-24.7,28.6-.1.9-.9,1.6-1.9,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M117.3,497.3c-.6,0-1.2-.3-1.6-.8-4.4-6.5-13-9-19.5-5.5-.9.5-2,.1-2.5-.8-.5-.9-.1-2,.8-2.5,8.2-4.4,18.9-1.4,24.3,6.7.6.9.3,2-.5,2.6-.3.2-.7.3-1,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M723.7,492.8c-.6,0-1.1-.2-1.5-.7-17.3-22.6-44.2-34.4-70.3-30.8-1,.1-2-.6-2.1-1.6-.1-1,.6-2,1.6-2.1,27.5-3.8,55.7,8.6,73.8,32.2.6.8.5,2-.3,2.6-.3.3-.7.4-1.1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M573.6,488.7c-.5,0-1-.2-1.4-.7-.7-.8-.6-2,.2-2.6,11.4-9.7,25-16,39.2-18.2,1-.1,2,.5,2.1,1.6.2,1-.5,2-1.6,2.1-13.5,2.1-26.4,8.1-37.3,17.3-.3.3-.8.4-1.2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M635.8,476.9c-.6,0-1.2-.3-1.6-.9-.5-.9-.2-2,.6-2.6,11.8-7,26.6-7.5,38.7-1.3.9.5,1.3,1.6.8,2.5-.5.9-1.6,1.3-2.5.8-11-5.7-24.4-5.2-35.1,1.2-.3.2-.6.3-1,.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M792,499c-.5,0-.9-.2-1.3-.5-5.7-5.3-13.4-7.9-20.7-6.8-1,.1-2-.6-2.1-1.6s.6-2,1.6-2.1c8.4-1.2,17.2,1.7,23.7,7.8.8.7.8,1.9,0,2.6-.4.4-.9.6-1.4.6h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M343.9,564.7H64.1c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h279.9c1.9,0,3.5,1.6,3.5,3.5s-1.6,3.5-3.5,3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M453.6,564.7h-73.7c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h73.7c1.9,0,3.5,1.6,3.5,3.5s-1.6,3.5-3.5,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M86.6,706.5c-1,0-2-.4-2.7-1.2-35.7-42.3-25.8-102.7-25.3-105.2.3-1.9,2.1-3.2,4-2.9,1.9.3,3.2,2.1,2.9,4,0,.6-9.8,59.8,23.8,99.5,1.2,1.5,1.1,3.7-.4,5-.7.6-1.5.8-2.3.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M128.1,739.8c-.2,0-.4,0-.7,0-16.2-3.1-27.2-15.2-27.7-15.7-1.3-1.4-1.2-3.7.3-5,1.4-1.3,3.7-1.2,4.9.3h0c0,.1,10,10.9,23.8,13.5,1.9.4,3.1,2.2,2.8,4.1-.3,1.7-1.8,2.8-3.4,2.8h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M881.5,502.4h-51.5c6.1,0,11.1,5,11.1,11.1h0c0,6.1-5,11.1-11.1,11.1h51.5c6.1,0,11.1-5,11.1-11.1h0c0-6.1-5-11.1-11.1-11.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare2);
export default __webpack_public_path__ + "static/media/care2.7aea2ca60ec699ca8459afc69458bfe5.svg";
export { ForwardRef as ReactComponent };